import React, { useMemo, useState } from "react";
import { TabContent, TabPane, Nav, NavItem, NavLink } from "reactstrap";
import { Suspense } from "react";
import Loader from "components/Loader";
import { withTranslation } from "react-i18next";
import OpenInIcon from "assets/images/open_in_new.svg";
import styles from "../Dashboard.module.scss";
import ToggleButton from "../components/ToggleButton";
import constants from "../../../../constants";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { getStorage, setStorage } from "utils";
import { Tooltip } from "reactstrap";
import DashboardCommonChat from "./CommonChat";
import Separator from "assets/images/Separator.svg";
import { useAccountOwnerCommon } from "lib/Context/AccountOwner";
import NotAccessibleChatCheck from "Messenger/NotAccessibleChat";

export const chatWindowsName = {
  patient: "patient",
  internal: "internal",
  external: "external",
};
const tabName = {
  teamChat: 1,
  patientChat: 2,
};
const Chat = ({
  t,
  appliedOfficeFilters,
  isOwner,
  isStaff,
  profile,
  selectedOwner,
  isPatientConversationFeatureEnabled,
  isTeamConversationFeatureEnabled,
}) => {
  const cacheFilters = getStorage(
    constants.manageDashboardList.cache.dashboardChatCache,
  );
  const { dataAccessValues } = useAccountOwnerCommon();
  const cachedashboardTeamChatCache = getStorage(
    constants.manageDashboardList.cache.dashboardTeamChatCache,
  );
  const [activeTab, setActiveTab] = useState(cacheFilters?.activeTab || 1);
  const [activeToggle, setActiveToggle] = useState(
    cachedashboardTeamChatCache?.activeTab || 1,
  );
  const [currentChannel, setCurrentChannel] = useState(null);
  const [tooltipEditOpen, setTooltipEditOpen] = useState(false);
  const [addModalOpen, setAddModalOpen] = useState("");
  const history = useHistory();

  const { internalChatView, patientChatView, teamChatView } = useMemo(() => {
    return {
      teamChatView: activeTab === tabName.teamChat,
      internalChatView: activeToggle === 1,
      patientChatView: activeTab === tabName.patientChat,
    };
  }, [activeTab, activeToggle]);

  const handleTabChange = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
    setCurrentChannel(null);
    setStorage(constants.manageDashboardList.cache.dashboardChatCache, {
      activeTab: tab,
    });
  };

  const handleToggleChange = (toggle) => {
    setActiveToggle(toggle);
    setCurrentChannel(null);
    setStorage(constants.manageDashboardList.cache.dashboardTeamChatCache, {
      activeTab: toggle,
    });
  };

  const dashboardChatComponent = useMemo(
    () => (
      <DashboardCommonChat
        t={t}
        currentUser={profile}
        key={patientChatView ? "patient" : "teamChat"}
        selectedOwner={selectedOwner}
        currentChannel={currentChannel}
        addModalOpen={addModalOpen}
        setAddModalOpen={setAddModalOpen}
        setCurrentChannel={setCurrentChannel}
        setViewAppointmentCred={() => {}}
        appliedOfficeFilters={appliedOfficeFilters}
        isFromPatientChat={patientChatView}
        externalTabActive={
          teamChatView && !internalChatView && !patientChatView
            ? true
            : undefined
        }
        isInternalChat={teamChatView && internalChatView ? true : undefined}
      />
    ),
    [
      profile,
      selectedOwner,
      currentChannel,
      addModalOpen,
      appliedOfficeFilters,
      patientChatView,
      teamChatView,
      internalChatView,
      t,
    ],
  );
  const handleRedirect = () => {
    if (teamChatView) {
      history.push(constants.routes.chatModule);
    } else {
      history.push(constants.routes.patientChatModule);
    }
    setStorage("isChatFromDashBoard", true);
    localStorage.setItem(
      constants.localStorageKeys.selectedChatAccountOwner,
      JSON.stringify(selectedOwner),
    );
  };
  const patientChatCheck =
    (isOwner || (isStaff && dataAccessValues?.isPatientChat)) &&
    isPatientConversationFeatureEnabled;
  const teamChatCheck =
    (isOwner || (isStaff && dataAccessValues?.isMessenger)) &&
    isTeamConversationFeatureEnabled;
  return (
    <div className={styles.chat_tab_wrapper}>
      <div className={styles.header_wrapper}>
        <Nav tabs className={styles["nav-tabs"]}>
          <NavItem className={styles["nav-items"]}>
            <NavLink
              className={teamChatView ? styles["active"] : styles["not-active"]}
              onClick={() => handleTabChange(tabName.teamChat)}
            >
              {t("dashBoard.teamChat")}
            </NavLink>
          </NavItem>
          <NavItem className={styles["nav-items"]}>
            <NavLink
              className={
                "px-1 " +
                (patientChatView ? styles["active"] : styles["not-active"])
              }
              onClick={() => handleTabChange(tabName.patientChat)}
            >
              {t("messenger.patientLiveChat")}
            </NavLink>
          </NavItem>
        </Nav>
        <NotAccessibleChatCheck
          patientCheck={patientChatView}
          dontRenderAnyChildren
        >
          <div className="d-flex gap-xxs">
            <button
              className={styles["add-chat-button"]}
              onClick={() => {
                setAddModalOpen(() => {
                  if (patientChatView) {
                    return chatWindowsName.patient;
                  }
                  if (internalChatView) {
                    return chatWindowsName.internal;
                  }
                  return chatWindowsName.external;
                });
              }}
            >
              <img
                src={require("assets/images/plus-icon-outline.svg").default}
                alt="icon"
              />
            </button>
            <img src={Separator} alt="separator" />
            <div className="pr-3" onClick={handleRedirect}>
              <img src={OpenInIcon} alt="open-icon" id="chat_tooltip" />
            </div>
            <Tooltip
              isOpen={tooltipEditOpen}
              placement="top"
              target="chat_tooltip"
              toggle={() => {
                setTooltipEditOpen(!tooltipEditOpen);
              }}
            >
              {t("dashBoard.gotoMessenger")}
            </Tooltip>
          </div>
        </NotAccessibleChatCheck>
      </div>

      {teamChatView && (
        <ToggleButton
          activeToggle={activeToggle}
          setActiveToggle={handleToggleChange}
          firstText="INTERNAL"
          secondText="EXTERNAL"
          isFromChat={true}
          isAccessible={teamChatCheck}
        />
      )}

      <TabContent
        activeTab={activeTab}
        className={`${styles.chatTabContent} ${
          patientChatView
            ? patientChatCheck
              ? styles.patientChat
              : styles.patientChat_new
            : teamChatCheck
              ? styles.otherChat
              : styles.otherChat_new
        }`}
      >
        <Suspense fallback={<Loader />}>
          <TabPane
            tabId={tabName.teamChat}
            className={`${styles.chatPane}${
              (!isPatientConversationFeatureEnabled && patientChatView) ||
              (!isTeamConversationFeatureEnabled && teamChatView)
                ? " " + styles.subscriptionModel
                : ""
            } ${teamChatCheck ? "" : " " + styles.notAccessible}`}
          >
            {teamChatView && (
              <div className={styles.chatPane}>
                <NotAccessibleChatCheck
                  patientCheck={false}
                  message={t("dashBoard.notAccessible")}
                >
                  {dashboardChatComponent}
                </NotAccessibleChatCheck>
              </div>
            )}
          </TabPane>

          <TabPane tabId={tabName.patientChat} className={styles.chatPane}>
            {patientChatView && (
              <div
                className={`${
                  patientChatCheck ? "h-100" : styles.notAccessible
                }`}
              >
                <NotAccessibleChatCheck
                  patientCheck={true}
                  message={t("dashBoard.notAccessible")}
                >
                  {dashboardChatComponent}
                </NotAccessibleChatCheck>
              </div>
            )}
          </TabPane>
        </Suspense>
      </TabContent>
    </div>
  );
};

export default withTranslation()(Chat);
